export const ADMIN_USER_ID = '00000000-0000-0000-0000-000000000001';
export const MIN_PASSWORD_LENGTH = 6;
